import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
// Initialize i18n before rendering
import "./lib/i18n";

// Register FleetTracker Service Worker for offline tile caching on /track/* routes
if ("serviceWorker" in navigator && window.location.pathname.startsWith("/track")) {
  navigator.serviceWorker
    .register("/sw.js", { scope: "/track/" })
    .catch((err) => console.warn("SW registration failed:", err));
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
